import { useTranslation } from "@/common/providers/i18n-provider";
import { versusCopyKey } from "./shared-copy";
import type { CompareSharedConfig } from "./types";

/** Real config facts, kept compact so the decision evidence comes first. */
export function StatsSection({ config }: { config: CompareSharedConfig }) {
  const { t } = useTranslation();
  if (!config.stats?.length) return null;
  return (
    <div className="company-container">
      <dl className="compare-facts">
        {config.stats.map((key) => (
          <div key={key}>
            <dt>{t(versusCopyKey(config, `stats.${key}.label`))}</dt>
            <dd>{t(versusCopyKey(config, `stats.${key}.value`))}</dd>
          </div>
        ))}
      </dl>
    </div>
  );
}
